import React, { useRef, useState } from 'react';
import styled from 'styled-components';

// Replace this URL with your actual QR code image
// You can use a direct URL to your QR code image or import it
import QRCodeImage from '../assets/images/QR code gpay.jpeg';
//const QRCodeImage = "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=upi://pay?pa=biz.vistatec517@fbl&pn=Vista%20Tech&am=3000&cu=INR";

// Styled Components
export const StyledContainer = styled.div`
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, #1a2a6c 0%, #b21f1f 50%, #fdbb2d 100%);
`;

export const FormWrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  
  h1 {
    text-align: center;
    color: #1a2a6c;
    margin-bottom: 1rem;
  }
`;

export const RegistrationCounter = styled.div`
  background-color: #1a2a6c;
  color: white;
  padding: 0.75rem;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const InternshipDetails = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background-color: #f5f7fa;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  
  h3 {
    color: #1a2a6c;
    margin-bottom: 1rem;
    text-align: center;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {
    padding: 0.5rem 0;
    display: flex;
    align-items: flex-start;
    
    &:before {
      content: "•";
      color: #b21f1f;
      font-weight: bold;
      margin-right: 0.5rem;
    }
  }
  
  .highlight {
    font-weight: 600;
    color: #1a2a6c;
  }
  
  .course-content {
    margin-top: 1rem;
    border-top: 1px solid #e0e0e0;
    padding-top: 1rem;
    
    h4 {
      color: #1a2a6c;
      margin-bottom: 0.5rem;
      padding: 0.5rem;
      background-color: #e8f4fd;
      border-radius: 6px;
    }
    
    h5 {
      color: #b21f1f;
      margin-bottom: 0.5rem;
      margin-top: 1rem;
      font-size: 1rem;
    }
    
    p strong {
      color: #1a2a6c;
      display: block;
      margin-top: 0.5rem;
      margin-bottom: 0.3rem;
    }
  }
`;

export const BenefitsSection = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background-color: #fff8e1;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  
  h3 {
    color: #1a2a6c;
    margin-bottom: 1rem;
    text-align: center;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
    
    &:before {
      content: "✓";
      color: #4caf50;
      font-weight: bold;
      margin-right: 0.5rem;
    }
  }
`;

export const PriceSection = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background-color: #e8f5e9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  
  h3 {
    color: #1a2a6c;
    margin-bottom: 1rem;
  }
  
  .price {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1a2a6c;
  }
  
  .internship-free {
    font-weight: 600;
    color: #4caf50;
    margin-top: 0.5rem;
  }
`;

export const UPISection = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background-color: #f0f4f8;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  border: 2px solid #1a2a6c;
  
  h3 {
    color: #1a2a6c;
    margin-bottom: 1rem;
  }
  
  .qr-code-container {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    
    img {
      max-width: 200px;
      max-height: 200px;
      border: 3px solid #1a2a6c;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
  
  .qr-text {
    color: #666;
    font-size: 0.9rem;
    margin-bottom: 15px;
    font-style: italic;
  }
  
  .upi-id {
    font-size: 1.2rem;
    font-weight: bold;
    color: #b21f1f;
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
    border: 2px dashed #1a2a6c;
    margin: 10px 0;
    font-family: 'Courier New', monospace;
    letter-spacing: 1px;
  }
  
  .copy-button {
    background-color: #1a2a6c;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    margin-top: 10px;
    transition: background-color 0.3s ease;
    
    &:hover {
      background-color: #b21f1f;
    }
    
    &:active {
      transform: scale(0.98);
    }
  }
  
  .payment-note {
    margin-top: 15px;
    font-size: 0.95rem;
    color: #666;
    font-style: italic;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  label {
    font-weight: 500;
    color: #1a2a6c;
  }
`;

export const StyledInput = styled.input`
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  
  &:focus {
    border-color: #fdbb2d;
    outline: none;
  }
`;

export const StyledSelect = styled.select`
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  
  &:focus {
    border-color: #fdbb2d;
    outline: none;
  }
`;

export const SubmitButton = styled.button`
  padding: 1rem;
  background: #1a2a6c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background: #b21f1f;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
`;

export const SuccessMessage = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  background: #e6ffe6;
  color: #006400;
  border-radius: 8px;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  background: #ffe6e6;
  color: #640000;
  border-radius: 8px;
  text-align: center;
`;

export const CopySuccessMessage = styled.div`
  color: #4caf50;
  font-size: 0.9rem;
  margin-top: 5px;
  font-weight: 500;
`;

type TrackType = 'Java' | 'Python' | 'Data Analytics' | 'Data Science' | 'React' | 'Angular' | 'SQL';

interface FormData {
  name: string;
  phone: string;
  whatsapp: string;
  email: string;
  college?: string;
  company?: string;
  designation?: string;
  location: string;
  track: TrackType;
  paidAmount: string;
  employmentStatus: 'student' | 'professional';
  paymentScreenshotFileName?: string;
}

const VistaTechInternshipRegistration: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    phone: '',
    whatsapp: '',
    email: '',
    location: '',
    employmentStatus: 'student',
    track: 'Java',
    paidAmount: '',
  });

  const [paymentScreenshot, setPaymentScreenshot] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [registrationCount, setRegistrationCount] = useState<number>(15);
  const [copySuccess, setCopySuccess] = useState<boolean>(false);
  const formRef = useRef<HTMLFormElement>(null);

  const UPI_ID = "9894449002@okbizaxis";

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      // Check file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB limit. Please choose a smaller file.');
        e.target.value = ''; // Reset the input
        return;
      }
      
      setPaymentScreenshot(file);
      setFormData(prev => ({
        ...prev,
        paymentScreenshotFileName: file.name
      }));
    }
  };

  const copyUPIId = async () => {
    try {
      await navigator.clipboard.writeText(UPI_ID);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = UPI_ID;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  const validateForm = (data: FormData): boolean => {
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      alert('Please enter a valid email address');
      return false;
    }

    // Phone number validation
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(data.phone)) {
      alert('Phone number must be 10 digits');
      return false;
    }

    if (!phoneRegex.test(data.whatsapp)) {
      alert('WhatsApp number must be 10 digits');
      return false;
    }
    
    // Paid amount validation
    if (!data.paidAmount || isNaN(Number(data.paidAmount))) {
      alert('Please enter a valid payment amount');
      return false;
    }

    // Payment screenshot validation
    if (!paymentScreenshot) {
      alert('Please upload your payment screenshot');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm(formData)) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');
    setErrorMessage('');

    // Update with your actual Google Apps Script URL
    const GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzSsOXyyy59eH150sYmqkO19-VeBf-oZaIkAptF-QRgfAWvzqxDLncv1bEc2qagYEJT/exec';

    try {
      if (paymentScreenshot) {
        const reader = new FileReader();

        reader.onload = async () => {
          try {
            const base64String = reader.result as string;
            const base64Content = base64String.split(',')[1] || base64String;

            // Apps Script reads e.parameter — must send as URLSearchParams (form-encoded)
            const params = new URLSearchParams();
            params.append('action', 'submitInternshipRegistration');
            params.append('name', formData.name);
            params.append('phone', formData.phone);
            params.append('whatsapp', formData.whatsapp);
            params.append('email', formData.email);
            params.append('location', formData.location);
            params.append('employmentStatus', formData.employmentStatus);
            params.append('course', formData.track);
            params.append('paidAmount', formData.paidAmount);
            params.append('paymentScreenshotBase64', base64Content);
            params.append('screenshotMimeType', paymentScreenshot.type);
            params.append('screenshotFilename', paymentScreenshot.name);
            if (formData.college)      params.append('college',      formData.college);
            if (formData.company)      params.append('company',      formData.company);
            if (formData.designation)  params.append('designation',  formData.designation);

            await fetch(GOOGLE_APPS_SCRIPT_URL, {
              method: 'POST',
              body: params,
              mode: 'no-cors',
            });

            setIsSubmitting(false);
            setSubmitStatus('success');
            setRegistrationCount(prevCount => prevCount + 1);
            setFormData({
              name: '',
              phone: '',
              whatsapp: '',
              email: '',
              location: '',
              employmentStatus: 'student',
              track: 'Java',
              paidAmount: '',
            });
            setPaymentScreenshot(null);
            if (formRef.current) {
              formRef.current.reset();
            }
          } catch (error) {
            console.error('Error sending form data:', error);
            setIsSubmitting(false);
            setSubmitStatus('error');
            setErrorMessage('Error submitting form: ' + (error instanceof Error ? error.message : String(error)));
          }
        };

        reader.onerror = () => {
          setIsSubmitting(false);
          setSubmitStatus('error');
          setErrorMessage('Error reading file. Please try again with a different file.');
        };

        reader.readAsDataURL(paymentScreenshot);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
      setSubmitStatus('error');
      setErrorMessage('Error submitting form: ' + (error instanceof Error ? error.message : String(error)));
    }
  };

  return (
    <StyledContainer>
      <FormWrapper>
        <h1>VISTA TECH INTERNSHIP PROGRAMS</h1>

        
        {/* Benefits Section */}
        <BenefitsSection>
          <h3>BENEFITS OF THE PROGRAM</h3>
          <ul>
            <li>EXPERTS TRAINING</li>
            <li>COURSE CERTIFICATION</li>
            <li>INTERNSHIP CERTIFICATION</li>
            <li>LINKEDIN ENDORSEMENT</li>
            <li>LETTER OF RECOMMENDATION</li>
            <li>HANDS-ON PROJECT EXPERIENCE</li>
            <li>INDUSTRY-RELEVANT CURRICULUM</li>
          </ul>
        </BenefitsSection>
        
        {/* Price Section */}
        <PriceSection>
          <h3>PRICE OF THE COURSE</h3>
          <div className="price">TRAINING AMOUNT: RS.3000</div>
          <div style={{marginTop:'0.5rem', fontSize:'0.95rem', color:'#555'}}>Token Fee (Registration): RS.500</div>
        </PriceSection>
        
        {/* UPI Payment Section with QR Code */}
        <UPISection>
          <h3>Payment Details</h3>
          
          {/* QR Code Section */}
          <div className="qr-code-container">
            <img 
              src={QRCodeImage} 
              alt="Payment QR Code" 
              title="Scan this QR code to make payment"
            />
          </div>
          <p className="qr-text">Scan the QR code above to make payment</p>
          
          <p>Or pay using UPI ID:</p>
          <div className="upi-id">{UPI_ID}</div>
          <button 
            type="button" 
            className="copy-button" 
            onClick={copyUPIId}
          >
            📋 Copy UPI ID
          </button>
          {copySuccess && (
            <CopySuccessMessage>
              ✓ UPI ID copied to clipboard!
            </CopySuccessMessage>
          )}
          <div className="payment-note">
            Please make the payment and upload the screenshot before submitting the form
          </div>
        </UPISection>

        <StyledForm 
          ref={formRef}
          onSubmit={handleSubmit}
        >
          <FormGroup>
            <label htmlFor="name">Full Name *</label>
            <StyledInput
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="phone">Phone Number *</label>
            <StyledInput
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]{10}"
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="whatsapp">WhatsApp Number *</label>
            <StyledInput
              type="tel"
              id="whatsapp"
              name="whatsapp"
              value={formData.whatsapp}
              onChange={handleInputChange}
              pattern="[0-9]{10}"
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="email">Email ID *</label>
            <StyledInput
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="employmentStatus">You are a *</label>
            <StyledSelect
              id="employmentStatus"
              name="employmentStatus"
              value={formData.employmentStatus}
              onChange={handleInputChange}
              required
            >
              <option value="student">Student</option>
              <option value="professional">Working Professional</option>
            </StyledSelect>
          </FormGroup>

          {formData.employmentStatus === 'student' && (
            <FormGroup>
              <label htmlFor="college">College/University Name *</label>
              <StyledInput
                type="text"
                id="college"
                name="college"
                value={formData.college || ''}
                onChange={handleInputChange}
                required
              />
            </FormGroup>
          )}

          {formData.employmentStatus === 'professional' && (
            <>
              <FormGroup>
                <label htmlFor="company">Company Name *</label>
                <StyledInput
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company || ''}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <label htmlFor="designation">Designation *</label>
                <StyledInput
                  type="text"
                  id="designation"
                  name="designation"
                  value={formData.designation || ''}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>
            </>
          )}

          <FormGroup>
            <label htmlFor="location">Location *</label>
            <StyledInput
              type="text"
              id="location"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="track">Select Track *</label>
            <StyledSelect
              id="track"
              name="track"
              value={formData.track}
              onChange={handleInputChange}
              required
            >
              <option value="Java">Java</option>
              <option value="Python">Python</option>
              <option value="Data Analytics">Data Analytics</option>
              <option value="Data Science">Data Science</option>
              <option value="React">React</option>
              <option value="Angular">Angular</option>
              <option value="SQL">SQL</option>
            </StyledSelect>
          </FormGroup>

          <FormGroup>
            <label htmlFor="paidAmount">Paid Amount (in Rs.) *</label>
            <StyledInput
              type="number"
              id="paidAmount"
              name="paidAmount"
              value={formData.paidAmount}
              onChange={handleInputChange}
              placeholder="3000"
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="paymentScreenshot">Payment Screenshot (JPG/PNG/PDF) *</label>
            <StyledInput
              type="file"
              id="paymentScreenshot"
              name="paymentScreenshot"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={handleFileChange}
              required
            />
            <small>Max file size: 5MB</small>
          </FormGroup>

          <SubmitButton
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Register Now'}
          </SubmitButton>
        </StyledForm>

        {submitStatus === 'success' && (
          <SuccessMessage>Registration successful! We'll contact you soon with further details.</SuccessMessage>
        )}

        {submitStatus === 'error' && (
          <ErrorMessage>
            Something went wrong. Please try again or contact support.
            {errorMessage && <div style={{marginTop: '10px', fontSize: '0.9em'}}>{errorMessage}</div>}
          </ErrorMessage>
        )}
      </FormWrapper>
    </StyledContainer>
  );
};

export default VistaTechInternshipRegistration;